/* eslint-disable */
import React from "react";
import updateCompletions from "../updateCompletions.js";
import * as Datetime from "react-datetime";
import Select from "react-select";
import Editor from "react-ace";
import "brace/mode/pgsql";
import "brace/theme/sqlserver";
import "brace/ext/searchbox";
import NumberInput from "react-number-input";
import {
  dateFormat,
  timeFormat,
  setClientDateFormat,
  setClientDateTimeFormat,
  setServerDateFormat
} from "../utility";
import {
  Center,
  Container,
  FilterLine,
  FormTable,
  FormLabel,
  FormTd,
  FormTr,
  FormInputText,
  FormInputCheck,
  FormTextArea,
  FormButton,
  Headers,
  Picker,
  QueryEditor,
  Right,
  RightGroupList,
  RightGroup,
  Stepper,
  Tab,
  Tabs,
  TabSelected,
  Topbar,
  TopbarListItem,
  TableView,
  DatetimeRenderers
} from "./Base";
import { isString, isObject, evalOptions } from "../utility";

const steps = [
  { name: "Query & Filters" },
  { name: "Pivot & Charts" },
  { name: "Customize" }
];

export class ReportConfig extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fullScreen: false,
      selectedStep: 0,
      viewData: []
    };
  }
  setStep = selectedStep => this.setState({ selectedStep });
  toggle = () =>
    this.setState({
      fullScreen: !this.state.fullScreen
    });
  undo = () => {
    this.toggle();
    return this.props.onChange(Object.assign({}, this.props.databaseValue));
  };
  refetch = () => {
    let values = this.props.value.filterdata ? Object.keys(this.props.value.filterdata)
      .filter(key => key !== "undefined")
      .sort((a, b) => Number(a.substr(1)) - Number(b.substr(1)))
      .map(key => this.props.value.filterdata[key]) : [];
    const runDataSource = this.props.Session.RX_Page.withId(0).formcurrent.datasource;
    this.props.task_request({
      action: "customQuery",
      payload: {
        text: this.props.value.queries.browserselect.text,
        values,
        datasource: runDataSource || 1
      },
      success: result => {
        console.log("refetch success: ", result);
        this.setState(prevState => ({
          viewData: result
        }));
        return this.props.noop({});
      }
    });
  };
  render() {
    // console.log("this.props:", this.props);
    if (!this.state.fullScreen)
      return <div onClick={this.toggle}>{"Press to fullScreen"}</div>;
    else
      return (
        <Container
          Rows={"40px auto 60px"}
          Columns={"0 auto 0px"}
          Areas={'"top top top" "center center right" "bottom bottom bottom"'}
          style={{
            position: "fixed",
            left: "0",
            right: "0",
            top: "0",
            bottom: "0"
          }}
        >
          <Topbar {...this.props} Area={"top"}>
            <TopbarListItem
              position={"onright"}
              style={{ color: "#FFF", padding: "0" }}
              onClick={this.refetch}
              title={"Execute query with parameters"}
            >
              <span style={{ width: "25px" }} className={`fa fa-play`} />
            </TopbarListItem>
            <TopbarListItem
              position={"onright"}
              style={{ color: "#FFF", padding: "0" }}
              onClick={this.toggle}
              title={"Modify and return"}
            >
              <span style={{ width: "25px" }} className={`fa fa-check`} />
            </TopbarListItem>
            <TopbarListItem
              position={"onright"}
              style={{ color: "#FFF", padding: "0" }}
              onClick={this.undo}
              title={"Cancel modifications and return"}
            >
              <span style={{ width: "25px" }} className={`fa fa-times`} />
            </TopbarListItem>
          </Topbar>
          <Center Area={"center"} style={{ position: "relative" }}>
            {this.state.selectedStep === 0 && (
              <GridForm {...this.props} viewData={this.state.viewData} />
            )}
          </Center>
          <Right Area={"right"}>
            <div> {"right"} </div>
          </Right>
          <Stepper
            Area={"bottom"}
            steps={steps}
            selectedStep={this.state.selectedStep}
            setStep={this.setStep}
          />
        </Container>
      );
  }
}

export class FilterEditor extends React.Component {
  render() {
    // const filterdata = this.props.value.filterdata;
    const columns =
      this.props.value.filters && this.props.value.filters.columns
        ? this.props.value.filters.columns
        : [];
    // const databaseColumns = this.props.databaseValue.filters.columns;
    return (
      <div style={{ overflowY: "auto" }}>
        {columns && (
          <FormTable>
            <tbody>
              {columns.map((item, index) => (
                <FilterLine
                  {...this.props}
                  onChange={value => {
                    let filterdata = Object.assign(
                      {},
                      this.props.value.filterdata
                    );
                    if (isString(item.field)) {
                      if (item.field != value.field) {
                        delete filterdata[item.field];
                        filterdata[value.field] = undefined;
                      }
                    } else if (isObject(item.field)) {
                      Object.keys(item.field)
                        .filter(key => item.field[key] != value.field[key])
                        .map(key => {
                          delete filterdata[item.field];
                          return (filterdata[value.field[key]] = undefined);
                        });
                    }
                    return this.props.onChange(
                      Object.assign({}, this.props.value, {
                        filters: {
                          columns: columns.map(
                            (column, idx) => (index === idx ? value : column)
                          )
                        },
                        filterdata
                      })
                    );
                  }}
                  remove={() => {
                    let filterdata = Object.assign(
                      {},
                      this.props.value.filterdata
                    );
                    if (isString(item.field)) {
                      delete filterdata[item.field];
                    } else if (isObject(item.field)) {
                      Object.keys(item.field).map(
                        key => delete filterdata[item.field[key]]
                      );
                    }
                    return this.props.onChange(
                      Object.assign({}, this.props.value, {
                        filters: {
                          columns: columns.filter(
                            (column, idx) => index !== idx
                          )
                        },
                        filterdata
                      })
                    );
                  }}
                  item={item}
                  key={index}
                />
              ))}
            </tbody>
          </FormTable>
        )}
        <FormButton
          onClick={() =>
            this.props.onChange(
              Object.assign({}, this.props.value, {
                filters: {
                  columns: [
                    ...columns,
                    {
                      field: "",
                      type: "Text",
                      label: ""
                    }
                  ]
                }
              })
            )
          }
        >
          {"Add Filter"}
        </FormButton>
      </div>
    );
  }
}

// "New", "Clone", "Update"  şimdilik bunlar var, daha sonra guncellenebilir...
class FilterValues extends React.Component {
  render() {
    if (!this.props.value.filters) return <div />;
    return (
      <FormTable>
        <tbody>
          {this.props.value.filters.columns.map((item, index) => (
            <FilterFormLine
              {...this.props}
              key={index}
              item={item}
              value={
                this.props.value.filterdata &&
                  this.props.value.filterdata[item.field]
                  ? this.props.value.filterdata[item.field]
                  : ""
              }
              valueFirst={
                this.props.value.filterdata &&
                  this.props.value.filterdata[item.field.first]
                  ? this.props.value.filterdata[item.field.first]
                  : ""
              }
              valueSecond={
                this.props.value.filterdata &&
                  this.props.value.filterdata[item.field.second]
                  ? this.props.value.filterdata[item.field.second]
                  : ""
              }
              onCheckToggle={value =>
                this.props.onChange(
                  Object.assign({}, this.props.value, {
                    filters: {
                      columns: this.props.value.filters.columns.map(
                        (column, idx) =>
                          index === idx
                            ? { ...column, isChecked: value }
                            : column
                      )
                    }
                  })
                )
              }
              onChange={value =>
                this.props.onChange(
                  Object.assign({}, this.props.value, {
                    filterdata: Object.assign({}, this.props.value.filterdata, {
                      [item.field]: value
                    })
                  })
                )
              }
              onChangeFirst={value =>
                this.props.onChange(
                  Object.assign({}, this.props.value, {
                    filterdata: Object.assign({}, this.props.value.filterdata, {
                      [item.field.first]: value
                    })
                  })
                )
              }
              onChangeSecond={value =>
                this.props.onChange(
                  Object.assign({}, this.props.value, {
                    filterdata: Object.assign({}, this.props.value.filterdata, {
                      [item.field.second]: value
                    })
                  })
                )
              }
              onChangeCombined={({ first, second }) =>
                this.props.onChange(
                  Object.assign({}, this.props.value, {
                    filterdata: Object.assign({}, this.props.value.filterdata, {
                      [item.field.first]: first,
                      [item.field.second]: second
                    })
                  })
                )
              }
              onConfigChange={value =>
                this.props.onChange(
                  Object.assign({}, this.props.value, {
                    filters: {
                      columns: this.props.value.filters.columns.map(
                        (column, idx) => (index === idx ? value : column)
                      )
                    }
                  })
                )
              }
            />
          ))}
        </tbody>
      </FormTable>
    );
  }
}

class FilterFormLine extends React.Component {
  render() {
    let item = this.props.item;
    let value = this.props.value;
    let valueFirst = this.props.valueFirst;
    let valueSecond = this.props.valueSecond;
    return (
      <FormTr>
        <FormTd>
          <FormLabel>{item.label}</FormLabel>
        </FormTd>
        <FormTd>
          {item.type === "Text" && (
            <FormInputText
              value={value ? value : ""}
              name={item.label}
              onChange={e => this.props.onChange(e.target.value)}
            />
          )}
          {item.type === "Bool" && (
            <FormInputCheck
              checked={value}
              onChange={e => this.props.onChange(e.target.checked)}
            />
          )}
          {item.type === "Currency" && (
            <NumberInput
              value={value}
              onChange={(value, e) => this.props.onChange(value)}
              format="0,0[.]00"
            />
          )}
          {item.type === "Textarea" && (
            <FormTextArea
              value={value ? value : ""}
              onChange={e => this.props.onChange(e.target.value)}
            />
          )}
          {item.type === "Date" && (
            <Datetime
              utc={true}
              timeFormat={false}
              dateFormat={dateFormat}
              closeOnSelect={true}
              value={setClientDateFormat(value)}
              onChange={result =>
                this.props.onChange(setServerDateFormat(result))
              }
            />
          )}
          {item.type === "DateTime" && (
            <Datetime
              utc={true}
              timeFormat={timeFormat}
              dateFormat={dateFormat}
              closeOnSelect={true}
              value={setClientDateTimeFormat(value)}
              onChange={result =>
                this.props.onChange(setServerDateFormat(result))
              }
            />
          )}
          {item.type === "DateWeekOfMonth" && (
            <div
              style={{
                display: "flex"
              }}
            >
              <Datetime
                utc={true}
                renderDay={DatetimeRenderers.renderDay}
                timeFormat={false}
                dateFormat={dateFormat}
                closeOnSelect={true}
                value={setClientDateFormat(valueFirst)}
                onChange={first => {
                  let second = first
                    .clone()
                    .endOf("month")
                    .isBefore(first.clone().add(6, "days"))
                    ? first.clone().endOf("month")
                    : first.clone().add(6, "days");
                  return this.props.onChangeCombined({
                    first: setServerDateFormat(first),
                    second: setServerDateFormat(second)
                  });
                }}
              />
              <label
                style={{
                  fontSize: "14px",
                  margin: "auto",
                  marginLeft: "5px"
                }}
              >
                {valueSecond ? "-" + setClientDateFormat(valueSecond) : ""}
              </label>
            </div>
          )}
          {item.type === "DateInterval" && (
            <div>
              <Datetime
                utc={true}
                timeFormat={false}
                dateFormat={dateFormat}
                closeOnSelect={true}
                value={setClientDateFormat(valueFirst)}
                isValidDate={first =>
                  valueSecond ? first.isSameOrBefore(valueSecond) : true
                }
                onChange={result => {
                  console.log("first", result);
                  this.props.onChangeFirst(setServerDateFormat(result));
                }}
              />
              <Datetime
                utc={true}
                timeFormat={false}
                dateFormat={dateFormat}
                closeOnSelect={true}
                value={setClientDateFormat(valueSecond)}
                isValidDate={second =>
                  valueFirst ? second.isSameOrAfter(valueFirst) : true
                }
                onChange={result => {
                  console.log("second", result);
                  this.props.onChangeSecond(setServerDateFormat(result));
                }}
              />
            </div>
          )}
          {item.type === "DateTimeInterval" && (
            <div>
              <div style={{ display: "flex" }}>
                {(!item.isChecked || !item.isChecked.first) && (
                  <Datetime
                    utc={true}
                    timeFormat={timeFormat}
                    dateFormat={dateFormat}
                    closeOnSelect={true}
                    value={setClientDateTimeFormat(valueFirst)}
                    isValidDate={first =>
                      valueSecond ? first.isSameOrBefore(valueSecond) : true
                    }
                    onChange={result =>
                      this.props.onChangeFirst(setServerDateFormat(result))
                    }
                  />
                )}

                {item.isChecked &&
                  item.isChecked.first && (
                    <FormInputText
                      value={valueFirst ? valueFirst : ""}
                      name={item.label}
                      onChange={e => this.props.onChangeFirst(e.target.value)}
                    />
                  )}

                <FormInputCheck
                  checked={item.isChecked ? item.isChecked.first : false}
                  onChange={e =>
                    this.props.onCheckToggle({
                      first: e.target.checked,
                      second: item.isChecked ? item.isChecked.second : false
                    })
                  }
                />
              </div>
              <div style={{ display: "flex" }}>
                <Datetime
                  utc={true}
                  timeFormat={timeFormat}
                  dateFormat={dateFormat}
                  closeOnSelect={true}
                  value={setClientDateTimeFormat(valueSecond)}
                  isValidDate={second =>
                    valueFirst ? second.isSameOrAfter(valueFirst) : true
                  }
                  onChange={result =>
                    this.props.onChangeSecond(setServerDateFormat(result))
                  }
                />
                <FormInputCheck
                  checked={item.isChecked ? item.isChecked.second : false}
                  onChange={e =>
                    this.props.onCheckToggle({
                      first: item.isChecked ? item.isChecked.first : false,
                      second: e.target.checked
                    })
                  }
                />
              </div>
            </div>
          )}
          {item.type === "SelectIcon" && (
            <Picker Icon={value} SetIcon={icon => this.props.onChange(icon)} />
          )}
          {(item.type === "SelectQuery" ||
            item.type === "MultiSelectQuery" ||
            item.type === "SelectList" ||
            item.type === "MultiSelectList") && (
              <Select
                multi={
                  item.type === "MultiSelectList" ||
                    item.type === "MultiSelectQuery"
                    ? true
                    : false
                }
                value={value}
                options={evalOptions(item.options)}
                onChange={result =>
                  this.props.onChange(
                    !result
                      ? null
                      : item.type === "MultiSelectList" ||
                        item.type === "MultiSelectQuery"
                        ? result.map(item => item.value)
                        : result.value
                  )
                }
                onOpen={
                  item.type === "SelectList" || item.type === "MultiSelectList"
                    ? undefined
                    : () => {
                      this.props.task_request({
                        action: "customQuery",
                        payload: {
                          text: item.query.text,
                          values: ["%"]
                        },
                        success: result => {
                          console.log("onOpen result:", result);
                          return this.props.onConfigChange({
                            ...item,
                            options: Array.isArray(result) ? result : []
                          });
                        }
                      });
                    }
                }
                onInputChange={
                  item.type === "SelectList" || item.type === "MultiSelectList"
                    ? undefined
                    : val => {
                      this.props.task_request({
                        action: "customQuery",
                        payload: {
                          text: item.query.text,
                          values: ["%" + val + "%"]
                        },
                        success: result =>
                          this.props.onConfigChange({
                            ...item,
                            options: Array.isArray(result) ? result : []
                          })
                      });
                      return val;
                    }
                }
              />
            )}
        </FormTd>
      </FormTr>
    );
  }
}

class GridForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: 0
    };
  }
  selectTab(id) {
    this.setState(prevState => ({
      selected: id
    }));
  }
  render() {
    return (
      <RightGroupList
        style={{
          background: "rgb(224, 224, 224)",
          borderLeft: "1px solid #d0d0d0",
          minHeight: "100%"
        }}
      >
        <Tabs>
          {["Query", "Filters", "Filter Values", "Headers", "Table"].map(
            (item, idx) => {
              if (idx === this.state.selected) {
                return (
                  <TabSelected key={idx} onClick={e => this.selectTab(idx)}>
                    {item}
                  </TabSelected>
                );
              } else {
                return (
                  <Tab key={idx} onClick={e => this.selectTab(idx)}>
                    {item}
                  </Tab>
                );
              }
            }
          )}
        </Tabs>

        <RightGroup style={{ display: "flex" }}>
          {this.state.selected === 0 && (
            <div
              style={{ position: "relative", width: "100%", height: "100%" }}
            >
              <FormTable>
                <tbody>
                  <FormTr>
                    <FormTd >
                      <FormInputCheck
                        checked={
                          this.props.value &&
                            this.props.value.queries &&
                            this.props.value.queries.browserselect
                            ? this.props.value.queries.browserselect.isProcedure
                            : false
                        }
                        onChange={e =>
                          this.props.onChange(
                            Object.assign({}, this.props.value, {
                              queries: {
                                browserselect: {
                                  ...(this.props.value &&
                                    this.props.value.queries &&
                                    this.props.value.queries.browserselect
                                    ? this.props.value.queries.browserselect
                                    : {}),
                                  isProcedure: e.target.checked
                                }
                              }
                            })
                          )
                        }
                      />
                      <FormLabel>{"Is procedure"}</FormLabel>
                    </FormTd>
                  </FormTr>
                  <FormTr>
                    <FormTd>
                      <QueryEditor
                        SaveQuery={txt =>
                          this.props.onChange(
                            Object.assign({}, this.props.value, {
                              queries: { browserselect: { text: txt } }
                            })
                          )
                        }
                        Query={
                          this.props.value.queries &&
                            this.props.value.queries.browserselect
                            ? this.props.value.queries.browserselect.text
                            : ""
                        }
                      />
                    </FormTd>
                  </FormTr>
                </tbody>
              </FormTable>
            </div>
          )}
          {this.state.selected === 1 && <FilterEditor {...this.props} />}
          {this.state.selected === 2 && <FilterValues {...this.props} />}
          {this.state.selected === 3 && <Headers {...this.props} />}
          {this.state.selected === 4 && <TableView {...this.props} />}
        </RightGroup>
      </RightGroupList>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ReportConfig.js